// extracted by mini-css-extract-plugin
export default {"minPriceContainer":"min_price_panel_minPriceContainer__AFmYf","minPriceContent":"min_price_panel_minPriceContent__V6fhV","minPrice":"min_price_panel_minPrice__Z0obx"};